<template>
    <div class="settings">
        <div class="container-title">
            <div class="left">
                <h2 class="title">{{ $t('dash.settings.title') }}</h2>
            </div>
        </div>

        <div class="navigation">
            <router-link to="/dash/settings/account">
                <div :class="{ btn: true, account : true, active: ongletOpen === 'account' }">{{ $t('dash.settings.nav.account') }}</div>
            </router-link>

            <router-link to="/dash/settings/notifications">
                <div :class="{ btn: true, notifications : true, active: ongletOpen === 'notifications' }">{{ $t('dash.settings.nav.notifications') }}</div>
            </router-link>

            <router-link to="/dash/settings/users">
                <div :class="{ btn: true, users : true, active: ongletOpen === 'users' }">{{ $t('dash.settings.nav.manage_users') }}</div>
            </router-link>

            <router-link to="/dash/settings/billing" v-if="infoUser.admin">
                <div :class="{ btn: true, billing : true, active: ongletOpen === 'billing' }">{{ $t('dash.settings.nav.billing') }}</div>
            </router-link>

           
        </div>
        
        <div class="content-section-settings">
            <account v-if="ongletOpen=='account'" :infoUser="infoUser" :infoAccount="infoAccount" :updateInfoUser="updateInfoUser" :updateInfoAccount="updateInfoAccount"></account>
            <billing v-if="ongletOpen=='billing' && infoUser.admin" :infoUser="infoUser" :infoAccount="infoAccount" :updateInfoAccount="updateInfoAccount" :allPages="allPages"></billing>
            <notifications v-if="ongletOpen=='notifications'" :infoUser="infoUser" :updateInfoUser="updateInfoUser"></notifications>
            <users v-if="ongletOpen=='users'" :pages_access="Array.isArray(allPages) ? (infoUser.admin ? allPages : allPages.filter(page => infoUser.pages_access.includes(page.id))) : []" :groups="groups" :infoUser="infoUser"></users>
        </div>
    </div>
</template>

<script>
//component
import account from './../settings/account.vue'
import billing from './../settings/billing.vue'
import notifications from './../settings/notifications.vue'
import users from './../settings/users.vue'

//mixins
import SettingsMixins from '../../mixins/Settings.vue'
import UserMixins from '../../mixins/User.vue'
import PagesMixins from '../../mixins/Pages.vue'
import GroupsMixins from '../../mixins/Groups.vue'

import { EventBus } from '@/event-bus';

export default {
    name: 'settings',

    components : {
        account,
        billing,
        notifications,
        users
    },

    mixins : [SettingsMixins,UserMixins,PagesMixins,GroupsMixins],

    data() {
        return {
            ongletOpen : ['account','billing','notifications','users'].includes(this.$route.params.tab) ? this.$route.params.tab : 'account',
            infoUser : {},
            infoAccount :{},
            allPages:{},
            groups: {}
        };
    },

    async mounted() {
      this.infoUser = JSON.parse(localStorage.user);

      this.readAccount(this.infoUser.account).then(res => {
        this.infoAccount = res.body.account;
      })

      let getPages = this.infoUser.admin ? this.getAllPages : this.getPages
           
      // this.getPages().then(res => { //task clement a verifier avec aimine si il y a besoin de redemander les pages 
      getPages().then(res => { //task clement a verifier avec aimine si il y a besoin de redemander les pages 
          const { pages } = res.body
          this.allPages = pages
          // localStorage.setItem('pages', JSON.stringify(pages))
      })
      
      this.infoUser = await this.fetchUserInfo();

      this.getGroups().then(res => {
        this.groups = res
        if(!this.infoUser.admin){
          this.groups = this.groups.filter(g => g.pages.find(pageId => this.infoUser.pages_access.includes(pageId)))
        }
      })

    },

    

    watch : {
        '$route.params.tab': function (newTab, oldTab) {
            this.ongletOpen = ['account','billing','notifications','users'].includes(this.$route.params.tab) ? this.$route.params.tab : 'account';
        }
    },

    methods: {
        changeOnglet(ongletName){
            this.ongletOpen = ongletName;
        },


        refreshInfoUser() {
          if(localStorage.user){
            this.infoUser = JSON.parse(localStorage.user)
          }   
        },

        async updateInfoUser(data) {
         
          try {
            const res = await this.updateUser(data);
           
            const { success, user } = res.body;

            if (success !== true || 'error' in res.body) {
              alert("error updateUser");
              return false;
            }
            this.infoUser = user;
            localStorage.setItem('user', JSON.stringify(user));
            EventBus.$emit("handlerRefreshUser")
            return true;
          } catch (error) {
            alert("error updateUser");
            return false;
          }
        },

        async updateInfoAccount(data) {
          console.log("updateInfoAccount",data)
          try {
            const res = await this.updateAccount(data);
            console.log("response")
            const { success, account  } = res.body;

            if (success !== true || 'error' in res.body) {
              alert("error updateAccount");
              return false;
            }
            this.infoAccount = account;
            return true;
          } catch (error) {
            alert("error updateAccount");
            return false;
          }
        }


    },

    


   


   
};
</script>

<style lang="scss" scoped>

</style>